import type { ColumnDef, VisualizationConfig } from '@deckspace/types';
import { useSurfaceContext } from '../../components/surface/SurfaceContext';
import { ChartRenderer } from '../../components/ChartRenderer';

interface ScatterPlotViewProps {
  nodeId: string;
  mapping: { xValues: string; yValues: string };
  queryConfig?: Record<string, unknown>;
  displayConfig?: VisualizationConfig;
  minimized?: boolean;
  width?: number;
  height?: number;
  rows: Record<string, unknown>[];
  columnDefs: ColumnDef[];
}

const EMPTY_CONFIG: VisualizationConfig = {};

export function ScatterPlotView({
  nodeId,
  mapping,
  displayConfig,
  width,
  height,
  rows,
  columnDefs,
}: ScatterPlotViewProps) {
  const { themeKey } = useSurfaceContext();
  return (
    <ChartRenderer
      rows={rows}
      columnDefs={columnDefs}
      config={displayConfig ?? EMPTY_CONFIG}
      chartType="scatter"
      mapping={mapping}
      visualizationId={nodeId}
      themeKey={themeKey}
      width={width}
      height={height}
    />
  );
}
